// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MZlTr","contact":"Footer_contact__utkUs","follow":"Footer_follow__svJQP"};